export enum ENUM__color {
  BLACK = '#000000',
  WHITE = '#ffffff',
  BLUE = '#0000ff',
  RED = '#ff0000',
  GREEN = '#00ff00',
  YELLOW = '#F8D849',

  GRAY = '#808080',

  MASK_EMPTY = '#ffffff',
  MASK_ACTIVE = '#000000',
}
